<template>
  <page>

    <template slot="content">
    <tab :defaultActiveTabName="'member'">
      <template slot="btns">
        <tab-btn :title="'管理者'" :name="'admin'"></tab-btn>
        <tab-btn :title="'メンバー'" :name="'member'"></tab-btn>
      </template>
      <template slot="tabs">
        <tab-content :name="'member'">
          <list-group>
            <list-item :text="'グループに参加する'" :urlName="'FeaturesJoinClub'"></list-item>
            <list-item :text="'グループ管理者に連絡する'" :urlName="'FeaturesContactAdmin'"></list-item>
            <list-item :text="'ログインアカウントを変更する'" :urlName="'FeaturesBindingAccount'"></list-item>
            <list-item :text="'計測方法（データソース）を変更'" :urlName="'FeaturesSwitchDataSource'"></list-item>
            <list-item :text="'より正確な歩数計測方法(android)'" :urlName="'FeaturesImproveDataPrecision'"></list-item>
            <list-item :text="'データの同期（重要）'" :urlName="'FeaturesCheckDataSync'"></list-item>
            <list-item :text="'毎日ミッション'" :urlName="'FeaturesDailyMission'"></list-item>
            <list-item :text="'マイルを使う'" :urlName="'FeaturesBean'"></list-item>
            <list-item :text="'屋外ラン／ウォーク(GPS)'" :urlName="'FeaturesGPS'"></list-item>
            <list-item :text="'ランキングの確認'" :urlName="'FeaturesRank'"></list-item>
            <list-item :text="'グループ内イベントの確認'" :urlName="'FeaturesActivity'"></list-item>
            <list-item :text="'チャット'" :urlName="'FeaturesChat'"></list-item>
          </list-group>
        </tab-content>
        <tab-content :name="'admin'">
          <list-group>
            <list-item :text="'グループを作成する'" :urlName="'FeaturesAdminCreateClub'"></list-item>
            <list-item :text="'メンバーを招待する'" :urlName="'FeaturesAdminMemberJoin'"></list-item>
            <list-item :text="'参加パスワードの変更'" :urlName="'FeaturesAdminChangeJoinPassword'"></list-item>
            <list-item :text="'グループ情報の変更'" :urlName="'FeaturesAdminUpdateClubInfo'"></list-item>
            <list-item :text="'部門組織の登録'" :urlName="'FeaturesAdminUpdateTeam'"></list-item>
            <list-item :text="'メンバー情報の変更と削除（退会）'" :urlName="'FeaturesAdminUpdateMember'"></list-item>
            <list-item :text="'グループ管理者の変更'" :urlName="'FeaturesAdminSetAdmin'"></list-item>
            <list-item :text="'イベントの作成'" :urlName="'FeaturesAdminCreateActivity'"></list-item>
            <list-item :text="'イベントの複製'" :urlName="'FeaturesAdminCopyActivity'"></list-item>
            <list-item :text="'イベントの削除とアーカイブ'" :urlName="'FeaturesAdminDeleteActivity'"></list-item>
            <list-item :text="'イベントデータのエクスポート'" :urlName="'FeaturesAdminExportActivityResult'"></list-item>
          </list-group>
          <list-group :title="'イベント  作成 / 設定'">
            <list-item :text="'バーチャルラリーイベント'" :urlName="'FeaturesAdminCreateVirtualPathActivity'"></list-item>
            <list-item :text="'1万歩目標達成レース'" :urlName="'FeaturesAdminCreateKeepActivity'"></list-item>
            <list-item :text="'歩数ランキングレース'" :urlName="'FeaturesAdminCreateCommonActivity'"></list-item>
            <list-item :text="'GPS屋外ランニングレース'" :urlName="'FeaturesAdminCreateGPSRunActivity'"></list-item>
            <list-item :text="'GPS屋外ウォーキングレース'" :urlName="'FeaturesAdminCreateGPSActivity'"></list-item>
          </list-group>
        </tab-content>
      </template>
    </tab>
    </template>

  </page>
</template>

<script>
  import ListGroup from '@/components/ListGroup'
  import ListItem from '@/components/ListItem'
  import Tab from '@/components/Tab'
  import TabBtn from '@/components/TabBtn'
  import TabContent from '@/components/TabContent'
  import Page from '@/components/Page'

  export default {
    components: {
      ListGroup,
      ListItem,
      Tab,
      TabBtn,
      TabContent,
      Page
    },
    created: function () {
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/FeaturesList.vue